import React, { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconLink: React.FC<PropsType> = ({ color, style }) => {
  const iconFillColor = color || '#292929';
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <path
        d='M6.75 16C5.43583 16 4.31562 15.5613 3.38937 14.6838C2.46312 13.8063 2 12.745 2 11.5C2 10.255 2.46312 9.19375 3.38937 8.31625C4.31562 7.43875 5.43583 7 6.75 7H9.6C9.86917 7 10.0948 7.08625 10.2769 7.25875C10.459 7.43125 10.55 7.645 10.55 7.9C10.55 8.155 10.459 8.36875 10.2769 8.54125C10.0948 8.71375 9.86917 8.8 9.6 8.8H6.75C5.95833 8.8 5.28542 9.0625 4.73125 9.5875C4.17708 10.1125 3.9 10.75 3.9 11.5C3.9 12.25 4.17708 12.8875 4.73125 13.4125C5.28542 13.9375 5.95833 14.2 6.75 14.2H9.6C9.86917 14.2 10.0948 14.2863 10.2769 14.4588C10.459 14.6313 10.55 14.845 10.55 15.1C10.55 15.355 10.459 15.5688 10.2769 15.7413C10.0948 15.9138 9.86917 16 9.6 16H6.75ZM8.65 12.4C8.38083 12.4 8.15521 12.3138 7.97312 12.1413C7.79104 11.9688 7.7 11.755 7.7 11.5C7.7 11.245 7.79104 11.0312 7.97312 10.8588C8.15521 10.6863 8.38083 10.6 8.65 10.6H14.35C14.6192 10.6 14.8448 10.6863 15.0269 10.8588C15.209 11.0312 15.3 11.245 15.3 11.5C15.3 11.755 15.209 11.9688 15.0269 12.1413C14.8448 12.3138 14.6192 12.4 14.35 12.4H8.65ZM13.4 16C13.1308 16 12.9052 15.9138 12.7231 15.7413C12.541 15.5688 12.45 15.355 12.45 15.1C12.45 14.845 12.541 14.6313 12.7231 14.4588C12.9052 14.2863 13.1308 14.2 13.4 14.2H16.25C17.0417 14.2 17.7146 13.9375 18.2687 13.4125C18.8229 12.8875 19.1 12.25 19.1 11.5C19.1 10.75 18.8229 10.1125 18.2687 9.5875C17.7146 9.0625 17.0417 8.8 16.25 8.8H13.4C13.1308 8.8 12.9052 8.71375 12.7231 8.54125C12.541 8.36875 12.45 8.155 12.45 7.9C12.45 7.645 12.541 7.43125 12.7231 7.25875C12.9052 7.08625 13.1308 7 13.4 7H16.25C17.5642 7 18.6844 7.43875 19.6106 8.31625C20.5369 9.19375 21 10.255 21 11.5C21 12.745 20.5369 13.8063 19.6106 14.6838C18.6844 15.5613 17.5642 16 16.25 16H13.4Z'
        fill={iconFillColor}
      />
    </svg>
  );
};

export default SvgIconLink;
